<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M8.535 11A3.976 3.976 0 0 1 8 9c0-.264.026-.522.074-.771L6 6.5v-2L10 2h4l4 2.5v2l-2.074 1.729a4.018 4.018 0 0 1-.46 2.771A3.998 3.998 0 0 1 12 13a3.997 3.997 0 0 1-3.465-2Zm7.434-5.41L14.276 7H9.724L8.031 5.59 10.574 4h2.852l2.543 1.59ZM12 11a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2ZM3 21v-3c0-2.66 6.33-4 9-4s9 1.34 9 4v3H3Zm1.978-2.88.007-.015c-.003.01-.007.014-.007.014ZM5 18.081c.032-.045.107-.131.267-.257.39-.306 1.032-.635 1.89-.934 1.196-.417 2.546-.686 3.627-.81L10.2 19H9v-1H7v1H5v-.918Zm8.8.918-.584-2.92c1.081.125 2.431.394 3.627.811.858.299 1.5.628 1.89.934.16.126.235.212.267.257V19h-2v-1h-2v1h-1.2Zm5.222-.88s-.004-.006-.007-.015l.007.014Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
